import axios from 'axios';
import { API_BASE_URL } from '../config/api';

const API_BASE = `${API_BASE_URL}/api/mav`;

export const mavService = {
  // MAV References
  getReferences: async (filters = {}) => {
    const params = new URLSearchParams();
    if (filters.product_category) params.append('product_category', filters.product_category);
    if (filters.region) params.append('region', filters.region);
    if (filters.active_on) params.append('active_on', filters.active_on);
    const response = await axios.get(`${API_BASE}?${params}`);
    return response.data;
  },

  createReference: async (data) => {
    const response = await axios.post(API_BASE, data);
    return response.data;
  },

  getReferenceById: async (id) => {
    const response = await axios.get(`${API_BASE}/${id}`);
    return response.data;
  },

  updateReference: async (id, data) => {
    const response = await axios.put(`${API_BASE}/${id}`, data);
    return response.data;
  },

  findApplicable: async (productCategory, region, date) => {
    const params = new URLSearchParams({ product_category: productCategory });
    if (region) params.append('region', region);
    if (date) params.append('date', date);
    const response = await axios.get(`${API_BASE}/find?${params}`);
    return response.data;
  },

  // Supplier Data Gaps
  getGaps: async (eLedgerId, filters = {}) => {
    const params = new URLSearchParams();
    if (filters.resolution_status) params.append('resolution_status', filters.resolution_status);
    const response = await axios.get(`${API_BASE}/gaps/${eLedgerId}?${params}`);
    return response.data;
  },

  createGap: async (data) => {
    const response = await axios.post(`${API_BASE}/gaps`, data);
    return response.data;
  },

  getGapById: async (id) => {
    const response = await axios.get(`${API_BASE}/gaps/detail/${id}`);
    return response.data;
  },

  applyMAVToGap: async (gapId, data) => {
    const response = await axios.post(`${API_BASE}/gaps/${gapId}/apply-mav`, data);
    return response.data;
  }
};

export default mavService;
